import pathsDataChart from "@/components/Charts/pathsDataChart.json";
import { UPDATE_EXPAND_FULLSCREEN } from "@core/store/action-constants";
import { mapActions, mapState } from "vuex";

export const EchartMixin = {
  computed: {
    ...mapState("expandFullscreen", {
      isActiveModal: ({ isActiveModal }) => isActiveModal
    }),
    
    toolbox () {
      return {
        feature: {
          myOpenFullWindow: this.fullScreenMode ? {
            show: true,
            title: this.$t(`common.components.chart.fullWindow.${ this.isActiveModal }`),
            icon: pathsDataChart[this.isActiveModal ? "close" : "open"],
            onclick: this.UPDATE_EXPAND_FULLSCREEN
          } : {},
          saveAsImage: {
            title: this.$t("common.components.chart.saveAsImage")
          }
        },
        showTitle: false,
        itemGap: 16,
        tooltip: {
          show: true,
          formatter: (param) => `<div>${ param.title }</div>`,
          textStyle: {
            fontSize: 12
          }
        }
      };
    }
  },
  
  methods: {
    ...mapActions("expandFullscreen", {
      UPDATE_EXPAND_FULLSCREEN
    })
  }
};